// extracted by mini-css-extract-plugin
export const tabs = "tabs-module--tabs--cvecY";
export const tabsTextWhite = "tabs-module--tabs-text-white--1rpM_";
export const tabsCenter = "tabs-module--tabs-center--3eeNv";
export const tabsContent = "tabs-module--tabs-content--2ipVV";